<template>
  <div class="empty-state">
    <div v-if="$slots.icon || icon" class="empty-state__icon">
      <slot name="icon">
        <q-icon v-if="icon" :name="icon" size="32px" />
      </slot>
    </div>
    <h2 class="empty-state__title">{{ title }}</h2>
    <p v-if="description" class="empty-state__body">{{ description }}</p>
    <div v-if="$slots.cta" class="empty-state__cta">
      <slot name="cta" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
  description?: string;
  icon?: string;
}>();
</script>

<style scoped lang="scss">
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-4);
  padding: var(--space-9) var(--space-6);
  text-align: center;
  color: var(--stone);

  &__icon { color: var(--ink); }
  &__title {
    margin: 0;
    font-family: var(--font-serif);
    font-size: var(--fs-h2);
    color: var(--ink);
    letter-spacing: var(--ls-h2);
  }
  &__body {
    margin: 0;
    max-width: 480px;
    font-size: var(--fs-body);
    color: var(--stone);
  }
  &__cta { margin-top: var(--space-3); }
}
</style>
